module.exports = __webpack_public_path__ + "img/logo_tokstok_atendimento.6957c9b3.svg";